import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { IdentityControllerGetAll$Params } from 'src/app/api/fn/identity/identity-controller-get-all';
import { UserItem } from 'src/app/api/models';
import { IdentityService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-user-picker',
  templateUrl: './modal-user-picker.component.html',
  styleUrls: ['./modal-user-picker.component.scss'],
})
export class ModalUserPickerComponent {
  @ViewChild('keywordFilter') keywordFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('dt1') dt1?: Table;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];

  question_title: string;
  registry_id?: number;
  isTechnician?: boolean;
  loading = false;
  totalRecords = 0;
  users: UserItem[] = [];
  selectedUserControl = new FormControl<UserItem | null>(null);

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private identityService: IdentityService
  ) {
    this.question_title = config.data.question_title;
    this.registry_id = config.data.registry_id;
    this.isTechnician = config.data.isTechnician ?? true;
    this.selectedUserControl.setValue(config.data.chosenUser ?? null);
  }

  loadUsers(event: TableLazyLoadEvent) {
    this.loading = true;

    const params: IdentityControllerGetAll$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      registry_id: this.registry_id,
      isTechnician: this.isTechnician,
      query: event.globalFilter?.[0] || undefined,
    };

    this.identityService.identityControllerGetAll(params).subscribe(res => {
      this.users = res.data!.list;
      this.totalRecords = res.data!.count;
      this.loading = false;
    });
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({ value: this.selectedUserControl.value });
  }
}
